/**
 * Geo country confirmation modal
 * Markup: snippets/jiwya-geo-modal.liquid
 * Styles: assets/jiwya-geo-modal.css
 */
(function () {
  'use strict';

  var STORE_PREFERENCE_KEY = 'jiwyaStorePreference';
  var modal = document.getElementById('jiwyaModal');
  var closeBtn = document.querySelector('.jiwya-close-btn');
  var countrySelect = document.getElementById('jiwyaCountrySelect');
  var enterBtn = document.getElementById('jiwyaEnterStore');

  if (!modal || !countrySelect || !enterBtn) return;

  function isThemeEditorContext() {
    var host = window.location.hostname || '';
    return Boolean(
      (window.Shopify && window.Shopify.designMode) ||
        host.indexOf('myshopify.com') !== -1 ||
        window.location.search.indexOf('preview_theme_id=') !== -1 ||
        window !== window.top
    );
  }

  function getCurrentStore() {
    var hostname = window.location.hostname;

    if (hostname.indexOf('jiwya.in') !== -1) return 'IN';
    if (hostname.indexOf('jiwya.com') !== -1) return 'US';
    return '';
  }

  function showModal() {
    if (isThemeEditorContext()) return;
    modal.classList.add('jiwya-modal--open');
    modal.setAttribute('aria-hidden', 'false');
  }

  function hideModal() {
    modal.classList.remove('jiwya-modal--open');
    modal.setAttribute('aria-hidden', 'true');
  }

  function cleanStoreSelectedParam() {
    if (isThemeEditorContext()) return;
    var url = new URL(window.location.href);
    url.searchParams.delete('store_selected');
    window.history.replaceState({}, document.title, url.pathname + url.search + url.hash);
  }

  // Theme editor / preview: never show modal or cross-domain redirect
  // (Shopify error: "Page is redirecting to an unsupported URL")
  if (isThemeEditorContext()) {
    hideModal();
    return;
  }

  var currentStore = getCurrentStore();
  var params = new URLSearchParams(window.location.search);
  var storeSelectedFromUrl = params.get('store_selected');

  // Cross-domain handoff: jiwya.com?store_selected=US → persist and stop prompting
  if (storeSelectedFromUrl) {
    localStorage.setItem(STORE_PREFERENCE_KEY, storeSelectedFromUrl);
    cleanStoreSelectedParam();
  }

  var savedPreference = localStorage.getItem(STORE_PREFERENCE_KEY);

  if (savedPreference && savedPreference === currentStore) {
    hideModal();
  } else {
    fetch('https://ipapi.co/json/')
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (
          data.country &&
          Array.prototype.some.call(countrySelect.options, function (opt) {
            return opt.value === data.country;
          })
        ) {
          countrySelect.value = data.country;
        }
        showModal();
      })
      .catch(function (err) {
        console.log('Geolocation failed:', err);
        showModal();
      });
  }

  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      // Closing = stay on current storefront
      if (currentStore) {
        localStorage.setItem(STORE_PREFERENCE_KEY, currentStore);
      }
      hideModal();
    });
  }

  enterBtn.addEventListener('click', function () {
    var selected = countrySelect.value;

    localStorage.setItem(STORE_PREFERENCE_KEY, selected);

    switch (selected) {
      case 'IN':
        window.location.href = 'https://jiwya.in?store_selected=IN';
        break;
      case 'US':
        window.location.href = 'https://jiwya.com?store_selected=US';
        break;
      default:
        if (currentStore) {
          localStorage.setItem(STORE_PREFERENCE_KEY, currentStore);
        }
        hideModal();
        break;
    }
  });
})();
